import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { ShieldCheck } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw !== pw2) return setErr("Passwords don't match");
    if (pw.length < 8) return setErr("Password must be at least 8 characters");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => nav("/login", { replace: true }), 1800);
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  const inputCls = "w-full bg-white border border-border rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary";

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-8" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-9 h-9 rounded-md bg-forest grid place-items-center text-white">
            <ShieldCheck className="w-5 h-5" strokeWidth={1.5} />
          </div>
          <div className="font-display font-bold text-lg">KREPP</div>
        </div>
        <div className="label mb-2">New password</div>
        <h2 className="font-display text-3xl font-semibold tracking-tight mb-6">Choose a new password</h2>

        {!token ? (
          <div className="text-sm text-secondary" data-testid="reset-no-token">Missing reset token. Open the link from your email.</div>
        ) : done ? (
          <div className="card-flat p-6" data-testid="reset-success">
            <div className="text-sm">Password updated. Redirecting to sign in…</div>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5" data-testid="reset-password-form">
            <div>
              <label className="label block mb-2">New password</label>
              <input type="password" required minLength={8} className={inputCls}
                     value={pw} onChange={(e) => setPw(e.target.value)}
                     data-testid="reset-pw-input" autoComplete="new-password" />
            </div>
            <div>
              <label className="label block mb-2">Confirm password</label>
              <input type="password" required minLength={8} className={inputCls}
                     value={pw2} onChange={(e) => setPw2(e.target.value)}
                     data-testid="reset-pw2-input" autoComplete="new-password" />
            </div>
            {err && <div className="text-sm text-secondary" data-testid="reset-error">{err}</div>}
            <button type="submit" disabled={loading} className="btn-primary w-full py-3" data-testid="reset-submit-btn">
              {loading ? "Updating…" : "Update password"}
            </button>
          </form>
        )}

        <div className="mt-8 text-sm text-muted-foreground">
          <Link to="/login" className="text-forest font-medium hover:underline">← Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
